// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IKnorbXCYQY4sY6BYlK_{margin-top:40px}.aYLKNZ6vE3j1eEi_tzhQ{grid-template-columns:repeat(2,1fr);gap:12px;display:grid}.R8EY8eIqBwBoP98h5uYs{gap:8px;padding:23px 16px}.ag4l4jENvknXFEKctfKj{max-width:492px!important;padding:8px 12px!important}.ag4l4jENvknXFEKctfKj>div,.ag4l4jENvknXFEKctfKj input{min-height:24px}.ztGyZE4ENDwGmqByPwVh{height:40px}.sItgqEebigA1yRHHtRQy{background:var(--background-neutral-primary);margin:48px 0 10px;position:-webkit-sticky;position:sticky;bottom:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggleItem": `IKnorbXCYQY4sY6BYlK_`,
	"cardsContainer": `aYLKNZ6vE3j1eEi_tzhQ`,
	"choiceTile": `R8EY8eIqBwBoP98h5uYs`,
	"teamsPlaceholder": `ag4l4jENvknXFEKctfKj`,
	"select": `ztGyZE4ENDwGmqByPwVh`,
	"action": `sItgqEebigA1yRHHtRQy`
};
export default ___CSS_LOADER_EXPORT___;
